import fileApi from '@/api/projectFile';
import categoryApi from '@/api/projectFileCategory';

let requestIsSent = false;

export default {
  namespaced: true,
  state: () => ({
    categories: {},
    files: {},
  }),
  getters: {},
  mutations: {
    setCategories(state, { projectId, categories }) {
      state.categories = { ...state.categories, [projectId]: categories };
    },
    setFiles(state, { projectId, files }) {
      state.files = { ...state.files, [projectId]: files };
    },
  },
  actions: {
    fetchCategories({ state, commit }, { projectId, force }) {
      if (force || !state.categories[projectId]) {
        categoryApi.fetchList({ project: projectId })
          .then(r => commit('setCategories', { projectId, categories: r.items }));
      }
    },
    fetchFiles({ state, commit }, { projectId, force }) {
      if (requestIsSent) return;

      requestIsSent = true;

      if (force || !state.files[projectId]) {
        fileApi.fetchList({ 'category.project': projectId })
          .then(r => {
            commit('setFiles', { projectId, files: r.items });
            requestIsSent = false;
          });
      }
    },
  },
};
